import { styled } from '@superset-ui/core';
import React from 'react';
import { supersetTheme as theme } from '@superset-ui/core';
import plusIcon from 'src/assets/images/datax/add.png';

// export enum DataxButtonType {
//     Primary,
//     Secondary,
//     Tertiary
// };

interface Props {
    text: string;
    onClick: () => void;
    
    // type?: DataxButtonType;
    showIcon?: boolean;
}

const Container = styled.button`
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    gap: .5rem;
    padding: .5rem .8rem;
    cursor: pointer;
    background: none;
    border: none;
    border-radius: 4px;

    // Color
    color: ${theme.colors.primary.base};

    // Hover
    &:hover {
        background: #F5F8FF;
    }
`;

const Text = styled.div`
    display: flex;
    font-weight: 500;
    font-size: 1rem;
    line-height: 1.3rem;
    color: #0046D9;
`;

const Button = (props: Props) => {

    return (
        <Container onClick={props.onClick}>
            {props.showIcon && (<img src={plusIcon} alt=''></img>)}
            <Text>{props.text}</Text>
        </Container>
    );
};

export default Button;